import { defineStore } from 'pinia';
import { ref } from 'vue';
import { TAB_VALUE } from '../ui-services/tabs.service';

export const useTabsManagementStore = defineStore('tabsManagement', {

  state: () => ({

    /** @type {import('vue').Ref<string> } */
    currentTab: ref(null),

  }),

  actions: {

    /** Set tab to order tab. */
    toOrderTab() {
      this.currentTab = TAB_VALUE.ORDERS;
    },

    /**
     * Set tab.
     * @param {string} tab Tab from URL.
     */
    setTab(tab) {
      if (Object.values(TAB_VALUE).includes(tab)) {
        this.currentTab = tab;
      } else {
        this.currentTab = TAB_VALUE.CLASS_REGISTRATIONS;
      }
    },
  },
});
